import { render, staticRenderFns } from "./document_categories.vue?vue&type=template&id=12a476f2&scoped=true&"
import script from "./document_categories.vue?vue&type=script&lang=js&"
export * from "./document_categories.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../shared/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12a476f2",
  null
  
)

export default component.exports